export default "__VITE_ASSET__s7OOB4Zq__"